import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { BUTTON_BG_COLOR, BUTTON_COLOR, BUTTON_HOVER_BG_COLOR } = constants;

let styles = {
  base: {
    fontSize: 20,
    zIndex: 1,
    backgroundColor: BUTTON_BG_COLOR,
    color: BUTTON_COLOR,
    borderRadius: 200,
    padding: '11px 14.5px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: BUTTON_HOVER_BG_COLOR
    },
    position: 'relative',
    top: '-80px',
    left: '20px'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/historymap/PlayButton.styles.js